import InputFieldSet from "../repository/inputFieldSet/InputFieldSet";
import { useState, useRef, useEffect } from "react";
import Cookies from "../repository/Cookies";
import useMain from "../common/MainContext";

export default function LanguageSelector({ languages }) {
  const { language, setLanguage } = useMain();

  const refLangSelector = useRef();
  const [fieldValues, setFieldValues] = useState({
    LanguageSelector: '',
  });

  function handleLanguageChanged(e) {
    const newLanguage = e.target.value;
    if (language !== newLanguage) {
      Cookies.set("lang", newLanguage);
      setLanguage(newLanguage);
    }
  }

  useEffect(() => {
    let cookies = Cookies.get();
    if (cookies.lang) {
      setLanguage(cookies.lang);
    }
  }, []);

  useEffect(() => {
    setFieldValues({
      LanguageSelector: language,
    });
  }, [language])

  return (
    <div>
      <InputFieldSet
        reference={refLangSelector}
        name="LanguageSelector"
        type="select"
        fieldValues={fieldValues}
        optionList={languages}
        handleInputBlur={handleLanguageChanged}
        handleInputChange={handleLanguageChanged}
        required={true}
      />
    </div>
  );
}
